import createReactComponent from '../createReactComponent';
export default createReactComponent('circle-letter-m', 'IconCircleLetterM', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M9 16v-8l3 5l3 -5v8', key: 'svg-1' }],
]);
